import { render, staticRenderFns } from "./SafeHtml.vue?vue&type=template&id=e87a4886&scoped=true"
import script from "./SafeHtml.vue?vue&type=script&lang=js"
export * from "./SafeHtml.vue?vue&type=script&lang=js"
import style0 from "./SafeHtml.vue?vue&type=style&index=0&id=e87a4886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87a4886",
  null
  
)

export default component.exports